import * as React from 'react';
import { ReactNode } from 'react';
import { MutationLevelEnum } from "../../types/mutation";
import { allAminoAcids, allNucleotides, aminoAcidFullNames, nucleotideNames } from "../../../../commons/units";

// by "unit" we mean amino-acid or nucleotide
// each unit is represented by a string with length 1

interface Props {
  level: MutationLevelEnum,
  selected: string[], // selected units; cannot be null (can be an empty array)
  disabled: string, // disabled unit (wild-type)
  position: number,
  selectUnitsForPosition (units: string[], position: number): void, // provides array with newly selected units
}

function MutationPopoverSelect(props: Props) {

  // Constants:
  const noUnitValue = "0";

  function renderUnits() {
    let units: string[];
    let names: {[key: string]: string};
    if (props.level === MutationLevelEnum.DNA) {
      units = allNucleotides;
      names = nucleotideNames;
    } else {
      units = allAminoAcids;
      names = aminoAcidFullNames;
    }
    const components: ReactNode[] = [];
    components.push(
      <option value={noUnitValue} key={noUnitValue}>Choose mutation at {props.position}</option>
    )
    for (let i = 0; i < units.length; i++) {
      const unit = units[i];
      const disabled = unit === props.disabled;
      components.push(
        <option value={unit} key={unit} disabled={disabled}>{unit} – {names[unit]}</option>
      );
      console.assert(unit !== noUnitValue, "noUnitValue should be unique");
    }
    return components;
  }

  const handleChange = ({ target }) => {
    const mutation = target.value;
    props.selectUnitsForPosition(mutation !== noUnitValue ? [mutation] : [], props.position);
    target.blur();  // remove focus to prevent changing mutation by arrows
  }

  if (props.position === null) {
    return null;
  }
  return (
    <select
      onChange={handleChange}
      value={props.selected.length > 0 ? props.selected[0] : noUnitValue}
    >
      {renderUnits()}
    </select>
  );
}

export default MutationPopoverSelect;
